import {
  DiscoverFilled,
  DiscoverOutline,
  HomeFilled,
  HomeOutline,
  PortfolioFilled,
  PortfolioOutline,
  ProfileFilled,
  ProfileOutline,
  TransactionsFilled,
  TransactionsOutline,
  WatchlistFilled,
  WatchlistOutline,
} from '@assets/svg'
import { environment } from '../config'
import { MenuIcons } from '@interfaces'
import { TBCC_MENU_ICONS } from '../clients/tbcc/menuIcons'
import { AvailableBusiness } from '../clients/features'

const DEFAULT_ICONS: MenuIcons = {
  discover: { filled: <DiscoverFilled />, outline: <DiscoverOutline /> },
  home: { filled: <HomeFilled />, outline: <HomeOutline /> },
  portfolio: { filled: <PortfolioFilled />, outline: <PortfolioOutline /> },
  profile: { filled: <ProfileFilled />, outline: <ProfileOutline /> },
  transactions: {
    filled: <TransactionsFilled />,
    outline: <TransactionsOutline />,
  },
  watchlist: { filled: <WatchlistFilled />, outline: <WatchlistOutline /> },
}

export const useMenuIcons = (): MenuIcons => {
  const opts: Record<AvailableBusiness, MenuIcons> = {
    heytrade: DEFAULT_ICONS,
    tbcc: TBCC_MENU_ICONS,
    bit2me: DEFAULT_ICONS,
    'unicredit-pl': DEFAULT_ICONS,
  }
  return opts[environment?.client]
}
